var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "rtl-flip-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 113.778c0-62.183 51.595-113.778 113.778-113.778h398.222v113.778h-398.222v796.441h796.441v-398.219h113.781v398.219c0 62.186-51.595 113.781-113.781 113.781h-796.441c-62.183 0-113.778-51.595-113.778-113.781v-796.441zM625.778 113.778v-113.778h398.222v398.222h-113.781v-204l-528.663 528.667-80.445-80.445 528.666-528.666h-203.998z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.ef647fc0e820e45debda1a6e9ac7427b.svg";
export { ForwardRef as ReactComponent };